import React from 'react'
import './theme/global.scss'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'
import Home from './containers/Home/Home'
import * as bsc from '@binance-chain/bsc-use-wallet'
import 'react-toastify/dist/ReactToastify.css';

import { ToastContainer } from 'react-toastify';
import { MemoryRouter as Router, Route, Switch } from 'react-router-dom'
import { config } from './helpers/config'

ReactDOM.render(
  <bsc.UseWalletProvider
    chainId={config.networkId}
    connectors={{
      bsc,
      walletconnect: {
        rpcUrl: config.web3Provider.toString(),
      }
    }}>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
    <Router>
      <Switch>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  </bsc.UseWalletProvider>,
  document.getElementById('outer-wrapper'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
